<template>
  <div class="fm-mn">
    <div
      :class="['fm-mn-item', { active: selected === node.uid }]"
      @click="$emit('select', node.uid)"
    >
      <button class="fm-mn-toggle" @click.stop="expanded = !expanded" v-if="node.children && node.children.length">
        <svg :class="{ rotated: expanded }" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd"/>
        </svg>
      </button>
      <span v-else class="fm-mn-spacer"></span>
      <span class="fm-mn-icon">📁</span>
      <span class="fm-mn-name">{{ node.name }}</span>
    </div>
    <div v-if="expanded && node.children && node.children.length" class="fm-mn-children">
      <FMMoveNode
        v-for="child in node.children"
        :key="child.uid"
        :node="child"
        :selected="selected"
        :current-path="currentPath"
        @select="$emit('select', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FMMoveNode',
  props: { node: Object, selected: String, currentPath: Array },
  data() { return { expanded: true } },
}
</script>

<style scoped>
.fm-mn { display: flex; flex-direction: column; }
.fm-mn-item {
  display: flex; align-items: center; gap: 4px;
  padding: 5px 8px; border-radius: var(--fm-radius-sm);
  cursor: pointer; font-size: 13px; color: var(--fm-text2);
  transition: background 0.1s;
}
.fm-mn-item:hover { background: var(--fm-surface3); color: var(--fm-text); }
.fm-mn-item.active { background: var(--fm-accent-glow); color: var(--fm-primary); font-weight: 500; }
.fm-mn-toggle {
  background: none; border: none; padding: 0;
  width: 16px; height: 16px; display: flex; align-items: center; justify-content: center;
  cursor: pointer; color: inherit;
}
.fm-mn-toggle svg { width: 12px; height: 12px; transition: transform 0.15s; }
.fm-mn-toggle svg.rotated { transform: rotate(90deg); }
.fm-mn-spacer { width: 16px; flex-shrink: 0; }
.fm-mn-icon { font-size: 13px; }
.fm-mn-name { flex: 1; }
.fm-mn-children { padding-left: 18px; }
</style>
